import { useEffect, useRef } from 'react'
import { trackElitePlansScreenLoaded } from '../analytics'
import { useElitePlansLanding } from '../ElitePlansLandingContext'
import { useElitePlansFromParam } from './useElitePlansFromParam'

/**
 * Fires one ScreenLoaded for the active Elite Plans route when `isReady`.
 * Encodes selected/locked plan id and `from` query into `eventId` only.
 */
export function useTrackElitePlansScreenLoadWhenReady(isReady: boolean) {
  const { analyticsScreen, selectedPlanId } = useElitePlansLanding()
  const from = useElitePlansFromParam()
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (!isReady || hasTrackedRef.current) {
      return
    }
    hasTrackedRef.current = true
    trackElitePlansScreenLoaded(analyticsScreen, {
      tier: selectedPlanId,
      from
    })
  }, [isReady, analyticsScreen, selectedPlanId, from])
}
